(function () {
  var ROOT_ID = "ra-gift-progress-root";
  var STORAGE_TOTAL_KEY = "raGiftLastTotal";
  var STORAGE_CELEBRATED_KEY = "raGiftCelebratedAmounts";

  // ----------------- Config -----------------
  function getConfig() {
    var defaultConfig = {
      currencySymbol: "$",
      thresholds: [
        { amount: 50, label: "Bonus Activated – Start earning rewards" },
        { amount: 100, label: "FREE $25 Bonus Fish" },
        { amount: 200, label: "FREE $40 Bonus Fish" },
        { amount: 400, label: "FREE $60 Bonus Fish" },
        { amount: 600, label: "FREE $100 Bonus Fish" },
        { amount: 1000, label: "FREE Shipping on this order" }
      ],
      copy: {
        empty: "Add fish to your cart to activate bonus rewards.",
        justStarted:
          "You’re on your way! Keep adding fish to unlock free bonuses.",
        close:
          "You’re so close to the next reward. One more fish might do it…",
        allUnlocked: "You unlocked EVERY reward on this order. Monster haul!"
      }
    };

    if (typeof window.raGiftConfig === "object" && window.raGiftConfig) {
      var merged = JSON.parse(JSON.stringify(defaultConfig));
      var user = window.raGiftConfig;

      if (user.currencySymbol) merged.currencySymbol = user.currencySymbol;
      if (
        Object.prototype.toString.call(user.thresholds) === "[object Array]"
      ) {
        merged.thresholds = user.thresholds;
      }
      if (typeof user.copy === "object" && user.copy !== null) {
        merged.copy = Object.assign({}, merged.copy, user.copy);
      }

      return merged;
    }

    return defaultConfig;
  }

  // ----------------- Cart + helpers -----------------

  // Map dollar thresholds to actual free gift VARIANT IDs
  // These are your real variant IDs:
  var FREE_GIFT_CONFIG = [
    { amount: 100, variantId: 52002976170273 }, // FREE $25 Bonus Fish
    { amount: 200, variantId: 52002976203041 }, // FREE $40 Bonus Fish
    { amount: 400, variantId: 52002976235809 }, // FREE $60 Bonus Fish
    { amount: 600, variantId: 52002976301345 }  // FREE $100 Bonus Fish
  ];

  function fetchCart() {
    return fetch("/cart.js", { credentials: "same-origin" }).then(function (
      res
    ) {
      if (!res.ok) throw new Error("Failed to load cart.js");
      return res.json();
    });
  }

  function formatMoney(amount, symbol) {
    return symbol + amount.toFixed(2);
  }

  function calculateState(cart, config) {
    var thresholds = (config.thresholds || []).slice().sort(function (a, b) {
      return a.amount - b.amount;
    });

    var total = (cart.total_price || 0) / 100;
    var reached = thresholds.filter(function (t) {
      return total >= t.amount;
    });

    var next = null;
    for (var i = 0; i < thresholds.length; i++) {
      if (total < thresholds[i].amount) {
        next = thresholds[i];
        break;
      }
    }

    var maxAmount =
      thresholds.length > 0 ? thresholds[thresholds.length - 1].amount : 0;
    var rawPercent =
      maxAmount > 0 ? Math.min(100, (total / maxAmount) * 100) : 0;
    var percent = rawPercent === 0 && total > 0 ? 5 : rawPercent; // show sliver

    return {
      config: config,
      thresholds: thresholds,
      total: total,
      reached: reached,
      next: next,
      percent: percent
    };
  }

  // ----------------- Free gift cart sync -----------------
  // Ensures ONLY the highest tier free gift is in the cart
  function syncFreeGifts(cart, state) {
    // Use subtotal in cents; fall back to total_price if needed
    var subtotalCents = cart.items_subtotal_price || cart.total_price || 0;
    var subtotalDollars = subtotalCents / 100;

    // Find the highest gift tier they qualify for
    var eligible = null;
    for (var i = 0; i < FREE_GIFT_CONFIG.length; i++) {
      var tier = FREE_GIFT_CONFIG[i];
      if (subtotalDollars >= tier.amount) {
        if (!eligible || tier.amount > eligible.amount) {
          eligible = tier;
        }
      }
    }

    var desiredVariantId = eligible ? eligible.variantId : null;
    var giftVariantIds = FREE_GIFT_CONFIG.map(function (t) {
      return t.variantId;
    });

    // Find all gift line items currently in the cart
    var giftLineItems = [];
    for (var j = 0; j < cart.items.length; j++) {
      var item = cart.items[j];
      if (giftVariantIds.indexOf(item.variant_id) !== -1) {
        giftLineItems.push({
          line: j + 1, // Shopify lines are 1-based
          variant_id: item.variant_id,
          quantity: item.quantity
        });
      }
    }

    var alreadyHasDesired = false;
    var changes = [];

    // Remove all wrong/extra gifts or duplicate desired gifts
    for (var k = 0; k < giftLineItems.length; k++) {
      var gl = giftLineItems[k];
      if (desiredVariantId && gl.variant_id === desiredVariantId) {
        // Keep only ONE of the desired gift
        if (!alreadyHasDesired) {
          alreadyHasDesired = true;

          // If somehow quantity > 1, drop it back to 1
          if (gl.quantity > 1) {
            changes.push({
              line: gl.line,
              quantity: 1
            });
          }
        } else {
          // Duplicate desired gift lines -> remove them
          changes.push({
            line: gl.line,
            quantity: 0
          });
        }
      } else {
        // Wrong gift for this tier -> remove
        changes.push({
          line: gl.line,
          quantity: 0
        });
      }
    }

    var promises = [];

    // If we should have a gift but don't, add it
    if (desiredVariantId && !alreadyHasDesired) {
      promises.push(
        fetch("/cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            id: desiredVariantId,
            quantity: 1,
            properties: {
              _free_gift: "true"
            }
          })
        })
      );
    }

    // Apply changes (removals/quantity fixes)
    if (changes.length > 0) {
      promises.push(
        fetch("/cart/change.js", {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            changes: changes
          })
        })
      );
    }

    if (!promises.length) {
      return Promise.resolve();
    }

    return Promise.all(promises).catch(function (err) {
      console.warn("[RobsAquatics gift bar] Failed to sync free gifts:", err);
    });
  }

  // ----------------- localStorage helpers -----------------
  function getStoredTotal() {
    try {
      if (typeof localStorage === "undefined") return null;
      var raw = localStorage.getItem(STORAGE_TOTAL_KEY);
      if (!raw) return null;
      var n = parseFloat(raw);
      if (isNaN(n)) return null;
      return n;
    } catch (e) {
      return null;
    }
  }

  function setStoredTotal(total) {
    try {
      if (typeof localStorage === "undefined") return;
      localStorage.setItem(STORAGE_TOTAL_KEY, String(total));
    } catch (e) {}
  }

  function getCelebratedAmounts() {
    try {
      if (typeof localStorage === "undefined") return [];
      var raw = localStorage.getItem(STORAGE_CELEBRATED_KEY);
      if (!raw) return [];
      var parts = raw.split(",");
      var list = [];
      for (var i = 0; i < parts.length; i++) {
        var n = parseFloat(parts[i]);
        if (!isNaN(n)) list.push(n);
      }
      return list;
    } catch (e) {
      return [];
    }
  }

  function rememberCelebrated(amount) {
    try {
      if (typeof localStorage === "undefined") return;
      var list = getCelebratedAmounts();
      if (list.indexOf(amount) === -1) {
        list.push(amount);
        localStorage.setItem(STORAGE_CELEBRATED_KEY, list.join(","));
      }
    } catch (e) {}
  }

  // ----------------- Toast helpers -----------------
  function findNewTier(prevTotal, currentTotal, thresholds, celebrated) {
    if (!thresholds.length || currentTotal <= 0) return null;

    var candidate = null;

    // If we know previous total and it increased this session, prefer that
    if (prevTotal != null && currentTotal > prevTotal) {
      for (var i = 0; i < thresholds.length; i++) {
        var t = thresholds[i];
        if (
          prevTotal < t.amount &&
          currentTotal >= t.amount &&
          celebrated.indexOf(t.amount) === -1
        ) {
          candidate = t;
        }
      }
      if (candidate) return candidate;
    }

    // Fallback: on fresh page load, celebrate the highest reached tier
    // that we haven't celebrated yet.
    for (var j = 0; j < thresholds.length; j++) {
      var tier = thresholds[j];
      if (
        currentTotal >= tier.amount &&
        celebrated.indexOf(tier.amount) === -1
      ) {
        candidate = tier;
      }
    }

    return candidate;
  }

  function showTierToast(tier) {
    if (!tier) return;

    var existing = document.querySelector(".ra-gift-toast");
    if (existing && existing.parentNode) {
      existing.parentNode.removeChild(existing);
    }
    if (window.raGiftToastTimeout) {
      clearTimeout(window.raGiftToastTimeout);
    }

    var el = document.createElement("div");
    el.className = "ra-gift-toast";
    el.innerHTML =
      '<span class="ra-gift-toast__title">Congrats! 🎉</span>' +
      '<span class="ra-gift-toast__body">You made it to the "' +
      tier.label +
      '" tier.</span>';

    document.body.appendChild(el);

    // trigger CSS transition
    requestAnimationFrame(function () {
      el.classList.add("ra-gift-toast--visible");
    });

    window.raGiftToastTimeout = setTimeout(function () {
      el.classList.remove("ra-gift-toast--visible");
      setTimeout(function () {
        if (el.parentNode) el.parentNode.removeChild(el);
      }, 250);
    }, 3000);
  }

  // ----------------- Markup -----------------
  function createMarkup(state) {
    var config = state.config;
    var total = state.total;
    var thresholds = state.thresholds;
    var reached = state.reached;
    var next = state.next;
    var percent = state.percent;

    var message;
    if (total <= 0) {
      message = config.copy.empty;
    } else if (!next && reached.length === thresholds.length && thresholds.length) {
      message = config.copy.allUnlocked;
    } else if (next && next.amount - total <= 25) {
      message = config.copy.close;
    } else {
      message = config.copy.justStarted;
    }

    var subline;
    if (!next && reached.length === 0) {
      subline = "Add items to start unlocking rewards.";
    } else if (!next && reached.length > 0) {
      subline = "You’ve unlocked all available rewards on this order.";
    } else {
      var remaining = next.amount - total;
      subline =
        "Only " +
        formatMoney(remaining, config.currencySymbol) +
        " more to unlock: " +
        next.label;
    }

    var tiersHtml = thresholds
      .map(function (t) {
        var isReached = total >= t.amount;
        var cls = isReached
          ? "ra-gift-tier ra-gift-tier--reached"
          : "ra-gift-tier";
        return (
          '<div class="' +
          cls +
          '">' +
          '<div class="ra-gift-tier__dot"></div>' +
          '<div class="ra-gift-tier__text">' +
          '<div class="ra-gift-tier__amount">' +
          formatMoney(t.amount, config.currencySymbol) +
          "</div>" +
          '<div class="ra-gift-tier__label">' +
          t.label +
          "</div>" +
          "</div>" +
          "</div>"
        );
      })
      .join("");

    var topLabel =
      formatMoney(total, config.currencySymbol) +
      " cart total · Unlock " +
      thresholds.length +
      " rewards";

    var maxThreshold = thresholds.length
      ? thresholds[thresholds.length - 1].amount
      : 0;
    var progressLabel = thresholds.length
      ? formatMoney(total, config.currencySymbol) +
        " / " +
        formatMoney(maxThreshold, config.currencySymbol)
      : formatMoney(total, config.currencySymbol);

    return (
      '<div class="ra-gift-bar">' +
      '<div class="ra-gift-bar__inner">' +
      '<div class="ra-gift-bar__header">' +
      '<div class="ra-gift-bar__title">Bonus Rewards Progress</div>' +
      '<div class="ra-gift-bar__topline">' +
      topLabel +
      "</div>" +
      "</div>" +
      '<div class="ra-gift-bar__message">' +
      "<strong>" +
      message +
      "</strong>" +
      "<br>" +
      subline +
      "</div>" +
      '<div class="ra-gift-bar__progress-wrap">' +
      '<div class="ra-gift-bar__progress-track">' +
      '<div class="ra-gift-bar__progress-fill" style="width:' +
      percent +
      '%"></div>' +
      "</div>" +
      '<div class="ra-gift-bar__progress-label">' +
      progressLabel +
      "</div>" +
      "</div>" +
      '<div class="ra-gift-bar__tiers">' +
      tiersHtml +
      "</div>" +
      "</div>" +
      "</div>"
    );
  }

  // ----------------- Render + listeners -----------------
  function render() {
    var root = document.getElementById(ROOT_ID);
    if (!root) return;

    fetchCart()
      .then(function (cart) {
        var config = getConfig();
        var state = calculateState(cart, config);

        var storedPrev = getStoredTotal();
        var prevTotal =
          typeof window.raGiftPrevTotal === "number"
            ? window.raGiftPrevTotal
            : storedPrev;
        var celebrated = getCelebratedAmounts();

        var newTier = findNewTier(
          prevTotal,
          state.total,
          state.thresholds,
          celebrated
        );

        // First, sync cart free gifts so only the highest tier gift is present
        return syncFreeGifts(cart, state).then(function () {
          // Then render the bar UI
          root.innerHTML = createMarkup(state);
          root.classList.add("ra-gift-progress-mounted");

          if (newTier) {
            showTierToast(newTier);
            rememberCelebrated(newTier.amount);
          }

          window.raGiftPrevTotal = state.total;
          setStoredTotal(state.total);
        });
      })
      .catch(function (err) {
        console.warn("[RobsAquatics gift bar] Failed to render:", err);
      });
  }

  function setupCartListeners() {
    if (window.__raGiftListenersSetup) return;
    window.__raGiftListenersSetup = true;

    // Theme-level cart events (if Dawn / similar fires them)
    var events = ["cart:updated", "cart:change", "cart:refresh"];
    for (var i = 0; i < events.length; i++) {
      document.addEventListener(events[i], function () {
        render();
      });
    }

    // Fallback: listen to Add to Cart clicks & re-render shortly after
    document.addEventListener("click", function (evt) {
      var target = evt.target;
      if (!target) return;

      var button = target.closest
        ? target.closest(
            'button[name="add"],button[name="add-to-cart"],form[action*="/cart/add"] [type="submit"]'
          )
        : null;

      if (button) {
        // give Shopify a moment to update cart, then refresh bar
        setTimeout(render, 800);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      render();
      setupCartListeners();
    });
  } else {
    render();
    setupCartListeners();
  }
})();